/* eslint-disable no-unused-expressions */

export const formatPermissions = (permissions = []) => {
  const formatted = {};

  permissions?.forEach((p) => {
    const key = p?.split('/')[0]?.replace('pzzl_', '');
    const value = p.split('/')[1];

    if (formatted[key]?.length > 0) formatted[key] = [...formatted[key], value];
    else formatted[key] = [value];
  });

  return formatted;
};

export const hasPermission = (permissions = [], key = '') => {
  return permissions?.includes(key);
};
